module.exports = __webpack_public_path__ + "img/slide-14.301f38cb.jpg";